import * as actionTypes from "../ActionTypes";
import { put, call, takeLatest, takeEvery } from "redux-saga/effects";
import * as api from "./ProfileAPI";
import { actionUpdateGlobalLoaderSagaAction } from "../GlobalLoader/GlobalLoaderAction";

function* getProfileRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action?.payload?.apiPayloadRequest || {};
    const response = yield call(api.getProfile, payload);
    action?.payload?.callback?.(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
    action?.payload?.callback?.({
      type: 0,
      message: err?.response?.data?.message || err?.message || "Profile fetch failed",
      data: [],
    });
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* saveUserProfileRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action?.payload?.apiPayloadRequest || {};
    const response = yield call(api.saveUserProfile, payload);
    action?.payload?.callback?.(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* updateUserProfileRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action?.payload?.apiPayloadRequest || {};
    const response = yield call(api.updateUserProfile, payload);
    action?.payload?.callback?.(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* getPickWhereLeftRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action?.payload?.apiPayloadRequest || {};
    const response = yield call(api.getPickWhereLeft, payload);
        action?.payload?.callback?.(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* readUserFavRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action?.payload?.apiPayloadRequest || {};
    const response = yield call(api.readUserFav, payload);
        action?.payload?.callback?.(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* getAchievementsRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action?.payload?.apiPayloadRequest || {};
    const response = yield call(api.getAchievements, payload);
        action?.payload?.callback?.(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

export default function* ProfileWatcherSaga() {
  yield takeEvery(actionTypes.GET_PROFILE_REQUEST, getProfileRequestSaga);
  yield takeLatest(actionTypes.SAVE_USER_PROFILE_REQUEST, saveUserProfileRequestSaga);
  yield takeLatest(actionTypes.UPDATE_USER_PROFILE_REQUEST, updateUserProfileRequestSaga);
  yield takeLatest(actionTypes.GET_PICK_WHERE_LEFT_REQUEST, getPickWhereLeftRequestSaga);
  yield takeLatest(actionTypes.READ_FAV_REQUEST, readUserFavRequestSaga);
  yield takeLatest(actionTypes.GET_ACHIEVEMENTS, getAchievementsRequestSaga);
}
